import { parentUrl } from '../../App/App.config'
import pushGTMEvent from '../../util/helper/pushGTMEvent'

const configContents = ({
  auth: { isAuthenticated, loginWithRedirect },
  state,
}) => {
  const { langStrings, user } = state
  const {
    hula: { welcome: { clickGetStarted, noteBullet1, noteBullet2 } = {} } = {},
    signIn: { helloUser, signInHelp, signInNow, startAccessAccount } = {},
    welcome: { noteForTheUser } = {},
  } = langStrings || {}

  const handleSignIn = () => {
    console.log('[HULA] Logging in with returnTo:', parentUrl)
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }

  let contents

  if (isAuthenticated) {
    contents = [
      {
        isTitle: true,
        hasNarrowBottom: true,
        description: langStrings
          ? helloUser.replace('<first-name>', user.firstName)
          : 'Hello <first-name>!',
        id: 'adsk-page-title',
      },
      {
        isTitle: true,
        hasLargeBottom: true,
        description: langStrings
          ? clickGetStarted
          : 'Click Get Started to change your contract manager.',
      },
    ]
  } else {
    contents = [
      {
        isTitle: true,
        hasLargeBottom: true,
        description: langStrings
          ? startAccessAccount
          : 'Let’s start with accessing your account.',
      },
      {
        description: langStrings ? signInNow : `<a>Sign in now</a>`,
        style: { fontSize: '21px', color: '#777', fontWeight: 600 },
        paragraphStyle: { marginBottom: '8px' },
        handleTextClick: () => handleSignIn(),
      },
      {
        description: langStrings
          ? signInHelp
          : '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/account-management/account-creation-sign-profile-management">Having trouble signing in?</a>',
        style: { color: '#777', fontWeight: 600 },
        paragraphStyle: { marginBottom: '40px' },
      },
    ]
  }

  contents.push(
    {
      description: langStrings ? noteForTheUser : 'Note:',
      style: { fontSize: '19px' },
      paragraphStyle: { marginBottom: '20px', lineHeight: '24px' },
    },
    {
      hasBullet: true,
      description: langStrings
        ? noteBullet1
        : 'You can change the contract manager for maintenance plans and subscriptions that are not auto-renewing.',
    },
    {
      hasBullet: true,
      description: langStrings
        ? noteBullet2
        : 'If you have an auto-renewing subscription, you will have to cancel the subscription and start a new one to change the contract manager.',
    },
  )
  pushGTMEvent('Welcome')
  return contents
}

const configFooter = ({
  auth: { isAuthenticated, loginWithRedirect },
  state: { langStrings },
  dispatch,
}) => {
  const getStarted = langStrings
    ? langStrings.buttons.getStartedButton
    : 'GET STARTED'
  const signIn = langStrings ? langStrings.buttons.signInButton : 'SIGN IN'

  const handleSignIn = () => {
    console.log('[HULA] Logging in with returnTo:', parentUrl)
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }

  const res = {
    hideBackButton: true,
    nextButtonContent: isAuthenticated ? getStarted : signIn,
    handleNext: () => {
      if (isAuthenticated) {
        pushGTMEvent('ContactInfo')
        dispatch({ type: 'GO_TO_REVIEW_ACCOUNT_PAGE' })
      } else handleSignIn()
    },
    handleNextButtonId: 'adsktm-cm-next-button',
  }
  return res
}
export default {
  configContents,
  configFooter,
}
